import { CompanyUser } from "generated/graphql";

export const STORAGE = window.localStorage! || null;

export const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY;
export const TOKEN_KEY_EXP = process.env.REACT_APP_TOKEN_KEY_EXP;
export const USER_ID = process.env.REACT_APP_USER_ID;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;;

type CurrentUserToken = {
  tokenKey: string;
  tokenExpDate: string;
};

export function getCurrentUserToken(): CurrentUserToken {
  return {
    tokenKey: STORAGE.getItem(TOKEN_KEY) || "",
    tokenExpDate: STORAGE.getItem(TOKEN_KEY_EXP) || "",
  };
}

export async function removeCurrentUserToken() {
  if (!STORAGE.getItem(TOKEN_KEY)) {
    throw new Error("Cannot remove current user token, was never stored in the first place!");
  }

  STORAGE.removeItem(TOKEN_KEY);
  STORAGE.removeItem(TOKEN_KEY_EXP);
}

export async function saveCurrentUserToken(token: string, expiresIn: string) {
  if (!token || !expiresIn) {
    throw new Error("Cannot complete the signing for this user, try again!");
  }
  STORAGE.setItem(TOKEN_KEY_EXP, expiresIn);
  STORAGE.setItem(TOKEN_KEY, token);
}

export async function storeUserId(user_id: string) {
  if (!user_id) {
    throw new Error("Cannot store user id");
  }
  STORAGE.setItem(USER_ID, user_id);
}
export async function storeCLientId(client_id: string) {
  if (!client_id) {
    throw new Error("Cannot store client id");
  }
  STORAGE.setItem(CLIENT_ID, client_id);
}

export async function removeUserId() {
  if (!STORAGE.getItem(USER_ID)) {
    throw new Error("Cannot remove current user token, was never stored in the first place!");
  }
  STORAGE.removeItem(USER_ID);
}
export async function removeClientId() {
  if (!STORAGE.getItem(CLIENT_ID)) {
    throw new Error("Cannot remove current user token, was never stored in the first place!");
  }
  STORAGE.removeItem(CLIENT_ID);
}

// export const isAllowed = (user:CompanyUser, rights) =>
//   rights.some(right => user.rights.includes(right));

export const hasRole = (user: CompanyUser, roles: string[]) =>
  roles?.some((role) => user?.company_user_profil === role);
